module.exports = __webpack_public_path__ + "img/news_mask_bg.0bb13780.png";